import Vue from 'vue'
import Vuex from 'vuex'
import file from './store/modules/tramsform'
import user from './store/modules/user'
import compress from './store/modules/compress'
import imgeditor from './store/modules/imgeditor'
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        file,
        user,
        compress,
        imgeditor
    }
});